module.exports = __webpack_public_path__ + "static/img/y34.ff6543c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y34.jpg
// module id = Gseh
// module chunks = 1